module.exports = __webpack_public_path__ + "files/604bf4d36ace40d1690cf583e802769e.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-57x57.png
// module id = 1242
// module chunks = 76